<div class="guest-search-container">
  <!-- Left Side - Search Box -->
  <div class="search-side">
    <div class="search-panel">
      <div class="panel-header">
        <mat-icon class="header-icon">search</mat-icon>
        <h2 class="panel-title">Pretraga gosta</h2>
      </div>

      <div class="search-form">
        <mat-form-field appearance="outline" class="search-input">
          <mat-label>Šifra rezervacije (IDENTIFIER)</mat-label>
          <input
            matInput
            [(ngModel)]="puroId"
            placeholder="XXXXXXXX"
            (keyup.enter)="onSearch()"
          />
          <mat-icon matPrefix class="input-icon">confirmation_number</mat-icon>
        </mat-form-field>

        <div class="search-buttons">
          <button
            mat-button
            (click)="onClear()"
            [disabled]="loading || !puroId"
            class="btn-secondary"
          >
            <mat-icon>clear</mat-icon>
            Očisti
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="onSearch()"
            [disabled]="loading || !puroId"
            class="btn-primary"
          >
            <mat-icon *ngIf="!loading">search</mat-icon>
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">Pretraži</span>
          </button>
        </div>

        <div *ngIf="error" class="error-message">
          <mat-icon>error_outline</mat-icon>
          <span>{{ error }}</span>
        </div>
      </div>

      <!-- Wristband Search Section -->
      <div class="wristband-search-section">
        <div class="section-divider">
          <div class="divider-line"></div>
          <span class="divider-text">ILI</span>
          <div class="divider-line"></div>
        </div>

        <mat-form-field appearance="outline" class="search-input">
          <mat-label>Broj narukvice</mat-label>
          <input
            matInput
            [(ngModel)]="wristbandId"
            placeholder="Unesite broj narukvice"
            (keyup.enter)="onWristbandSearch()"
          />
          <mat-icon matPrefix class="input-icon">watch</mat-icon>
        </mat-form-field>

        <button
          mat-raised-button
          color="accent"
          (click)="onWristbandSearch()"
          [disabled]="wristbandLoading || !wristbandId"
          class="btn-primary"
        >
          <mat-icon *ngIf="!wristbandLoading">search</mat-icon>
          <mat-spinner *ngIf="wristbandLoading" diameter="20"></mat-spinner>
          <span *ngIf="!wristbandLoading">Pretraži po narukvici</span>
        </button>

        <div *ngIf="wristbandError" class="error-message">
          <mat-icon>error_outline</mat-icon>
          <span>{{ wristbandError }}</span>
        </div>
      </div>

      <!-- Walk-in Section -->
      <div class="walkin-section">
        <div class="section-divider">
          <div class="divider-line"></div>
          <span class="divider-text">ILI</span>
          <div class="divider-line"></div>
        </div>

        <button
          mat-stroked-button
          color="primary"
          (click)="onOpenWalkInDialog()"
          class="btn-walkin"
        >
          <mat-icon>person_add</mat-icon>
          Kreiraj Walk-in
        </button>
      </div>
    </div>
  </div>

  <!-- Right Side - Reservation Details -->
  <div class="details-side">
    <!-- Empty State -->
    <div *ngIf="!reservation" class="empty-state">
      <div class="empty-state-content">
        <mat-icon class="empty-icon">person_search</mat-icon>
        <h3>Nema pronađene rezervacije</h3>
        <p>Unesite šifru rezervacije za pretragu gosta</p>
      </div>
    </div>

    <!-- Reservation Card -->
    <div *ngIf="reservation" class="reservation-panel">
      <div class="panel-header">
        <mat-icon class="header-icon">description</mat-icon>
        <h2 class="panel-title">Detalji rezervacije</h2>
      </div>

      <mat-card class="guest-card">
        <mat-card-header>
          <div mat-card-avatar class="guest-avatar">
            <mat-icon>person</mat-icon>
          </div>
          <div class="header-content">
            <div class="header-top">
              <mat-card-title>{{ reservation.name }}</mat-card-title>
              <mat-chip [class]="statusClass">{{ reservation.status }}</mat-chip>
            </div>
            <mat-card-subtitle>{{ reservation.email }}</mat-card-subtitle>
          </div>
        </mat-card-header>

        <div *ngIf="isCancelledStatus" class="status-warning">
          <mat-icon class="warning-icon">warning</mat-icon>
          <div class="warning-text">
            <h4>Nije moguće nastaviti s check-in</h4>
            <p>{{ statusMessage }}</p>
          </div>
        </div>

        <div *ngIf="showPaymentTypeInfo" [class]="isWalkIn ? 'payment-warning walkin-warning' : (isNotOperaLinked ? 'payment-warning online-paid-warning' : 'payment-info')" class="payment-type-indicator">
          <mat-icon [class]="isWalkIn ? 'walkin-icon' : 'payment-icon'">
            {{ isWalkIn ? 'money_off' : 'payment' }}
          </mat-icon>
          <div class="payment-text">
            <h4>{{ isWalkIn ? 'PAŽNJA: WALK-IN REZERVACIJA' : (isNotOperaLinked ? 'PAŽNJA: REZERVACIJA NIJE POVEZANA S OPEROM' : 'Tip plaćanja') }}</h4>
            <p>{{ paymentTypeMessage }}</p>
          </div>
        </div>

        <mat-card-content>
          <div class="reservation-details">
            <div class="detail-row">
              <span class="detail-label">
                <mat-icon>login</mat-icon>
                Dolazak:
              </span>
              <span class="detail-value">{{ parseDate(reservation.startDate) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">
                <mat-icon>logout</mat-icon>
                Odlazak:
              </span>
              <span class="detail-value">{{ parseDate(reservation.endDate) }}</span>
            </div>

            <div *ngIf="reservation.daysCount > 1" class="multi-day-badge">
              <mat-icon>calendar_today</mat-icon>
              <span>Višednevna rezervacija ({{ reservation.daysCount }} dana)</span>
            </div>

            <div class="detail-section">
              <div class="daily-payments">
                <h4 class="daily-payments-title">Rezervirano po datumu</h4>
                <div
                  *ngFor="let day of allDays"
                  class="daily-payment-row"
                  [class.today]="day.isToday"
                  [class.transfer-done]="day.transferDone"
                  [class.clickable]="day.transferDone"
                  (click)="day.transferDone ? onDayClick(day) : null">
                  <div class="payment-date">
                    {{ formatDate(day.date) }}
                    <mat-icon *ngIf="day.transferDone" class="transfer-done-icon">check_circle</mat-icon>
                  </div>
                  <div class="payment-info">
                    <span>{{day.roomName}}</span>
                    <span class="quantity">× {{day.quantity}}</span>
                  </div>
                  <div class="payment-amount">
                    = {{ (day.amount * (day.quantity ?? 1)).toFixed(2) }} {{ reservation.currency }}
                  </div>
                </div>
              </div>

              <div class="price-total">
                <div class="total-label">
                  <mat-icon>account_balance_wallet</mat-icon>
                  Ukupan iznos:
                </div>
                <span class="total-amount">
                  {{ reservation?.totalPrice?.toFixed(2) }} {{ reservation.currency }}
                </span>
              </div>
            </div>

            <div class="detail-section budget-section">
              <h3 class="section-title">
                <mat-icon>today</mat-icon>
                Iznos za danas :
              </h3>
              <div class="budget-display">
                <div class="budget-amount">
                  {{ dailyBudget }} {{ reservation.currency }}
                </div>
                <div class="budget-bar">
                  <div
                    class="budget-fill"
                    [class]="budgetClass"
                    [style.width.%]="budgetPercentage"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>

        <mat-card-actions align="end">
          <button
            mat-raised-button
            color="primary"
            (click)="onContinue()"
            [disabled]="!canContinue"
            class="btn-continue"
          >
            Nastavi
            <mat-icon fontIcon="arrow_forward"></mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
